var React = require('react');

function CheckGreen (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"10","fill":"#1FAD64","key":0}),React.createElement("path",{"d":"M14.7273 7L8.72727 13L6 10.2727","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckGreen.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CheckGreen;

CheckGreen.default = CheckGreen;
